// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"fa5f6075","769":"2017ea6a"}[chunkId] + ".chunk.js";
};